(function (jQuery) {
  jQuery.gfShadowAngle = function (element, options) {
    const defaults = {
      onSelected: function (value) {},
      onHistoryAdded: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let _value;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      if ($element.attr('value')) {
        _value = $element.attr('value');
      }
      if (_value == '') {
        _value = $element.attr('default_value');
      }

      _this.setTemplate();
      $element.on('value-change', function () {
        const value = $(this).val();
        _this.setValue(value);
      });
    };

    this.setTemplate = function () {
      let desc = '';
      if ($element.attr('data-description')) {
        desc = $element.attr('data-description');
      }

      const _template =
        ' <div class="gfShadowAngle"> <div class="gfSGSubTitle">' +
        _this.settings.title +
        '</div><div class="gfSGclear"></div><div class="gfSABody"> <div class="gfSALeft"> <div class="centered"> <div class="gfSAItem1"> <svg class="help-me-name-it-bruh" height="7px" viewBox="0 0 7 7"> <path d="M7,4H4v3H3V4H0l3.5-3.5L7,4z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSAItem2"> <svg class="help-me-name-it-bruh" height="7px" viewBox="0 0 7 7" style="transform:rotate(270deg);"> <path d="M7,4H4v3H3V4H0l3.5-3.5L7,4z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSACenter"> <div class="gfSAItem3"> <svg class="help-me-name-it-bruh" height="6px" viewBox="0 0 6 6" style="transform:rotate(270deg);"> <path d="M1.5,5.2L0.8,4.5l2.4-2.4L1,0h5v5L3.9,2.9L1.5,5.2z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSAItem4"> <svg class="help-me-name-it-bruh" height="6px" viewBox="0 0 6 6"> <path d="M1.5,5.2L0.8,4.5l2.4-2.4L1,0h5v5L3.9,2.9L1.5,5.2z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSAItem5"> <svg class="help-me-name-it-bruh" height="6px" viewBox="0 0 6 6" style="transform:rotate(180deg);"> <path d="M1.5,5.2L0.8,4.5l2.4-2.4L1,0h5v5L3.9,2.9L1.5,5.2z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSAItem6"> <svg class="help-me-name-it-bruh" height="6px" viewBox="0 0 6 6" style="transform:rotate(90deg);"> <path d="M1.5,5.2L0.8,4.5l2.4-2.4L1,0h5v5L3.9,2.9L1.5,5.2z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSACenterCenter"> </div> <div class="gfSACenterBorder"> <span></span> </div> </div> <div class="gfSAItem7"> <svg class="help-me-name-it-bruh" height="7px" viewBox="0 0 7 7" style="transform:rotate(90deg);"> <path d="M7,4H4v3H3V4H0l3.5-3.5L7,4z" style="fill: #4D5A66;" /> </svg> </div> <div class="gfSAItem8"> <svg class="help-me-name-it-bruh" height="7px" viewBox="0 0 7 7" style="transform:rotate(180deg);"> <path d="M7,4H4v3H3V4H0l3.5-3.5L7,4z" style="fill: #4D5A66;" /> </svg> </div> </div> </div> <div class="gfSARight"> <input type="text" /> <span>deg</span> </div> </div> </div>';

      $element.after(_template);
      _this.setValue(_value);
      const $gfShadowAngle = $element.next('.gfShadowAngle');

      // Event
      $gfShadowAngle
        .find('.gfSACenter')
        .off('mousedown.ShadowAngle')
        .on('mousedown.ShadowAngle', function (e) {
          const $that = jQuery(this),
            startX = $gfShadowAngle.find('.gfSACenterCenter').offset().left,
            startY = $gfShadowAngle.find('.gfSACenterCenter').offset().top;

          $gfLeftSideBar.off('mousemove.ShadowAngle').on('mousemove.ShadowAngle', function (e) {
            e.preventDefault();
            $gfShadowAngle.find('.centered').addClass('rotate');
            const x = e.pageX - startX;
            const y = e.pageY - startY;
            let g = Math.atan2(y, x) * (180 / Math.PI);
            g = g.toFixed(0);
            if (parseInt(g) < 0) {
              g = 360 + parseInt(g);
            }

            $gfShadowAngle.find('.gfSACenterBorder').css({
              transform: 'rotate(' + g + 'deg)',
            });

            $gfShadowAngle.find('.gfSARight input').val(g);
            _this.settings.onSelected(g);

            $element.attr('value', g).val(g).trigger('input-change');
          });

          $gfLeftSideBar.off('mouseup.ShadowAngle').on('mouseup.ShadowAngle', function (e) {
            const $target = jQuery(e.target);

            // Click vào vùng trong nhưng phải khác các mốc.
            const $parent = $target.closest('div');
            if (
              !$parent.hasClass('gfSAItem3') &&
              !$parent.hasClass('gfSAItem4') &&
              !$parent.hasClass('gfSAItem5') &&
              !$parent.hasClass('gfSAItem6')
            ) {
              $element.trigger('history-change');
              _this.settings.onHistoryAdded();
            }

            $gfShadowAngle.find('.centered').removeClass('rotate');
            $gfLeftSideBar.off('mouseup.ShadowAngle');
            $gfLeftSideBar.off('mousemove.ShadowAngle');
          });
        });

      $gfShadowAngle
        .find('.gfSACenter')
        .off('click')
        .on('click', function (e) {
          const $target = jQuery(e.target);
          if (
            $target.closest('.gfSACenterBorder').length == 0 &&
            $target.closest('.gfSAItem3').length == 0 &&
            $target.closest('.gfSAItem4').length == 0 &&
            $target.closest('.gfSAItem5').length == 0 &&
            $target.closest('.gfSAItem6').length == 0
          ) {
            $gfShadowAngle.find('.centered').addClass('rotate');

            const startX = $gfShadowAngle.find('.gfSACenterCenter').offset().left,
              startY = $gfShadowAngle.find('.gfSACenterCenter').offset().top;
            const x = e.pageX - startX;
            const y = e.pageY - startY;
            let g = Math.atan2(y, x) * (180 / Math.PI);

            g = g.toFixed(0);
            if (parseInt(g) < 0) {
              g = 360 + parseInt(g);
            }

            $gfShadowAngle.find('.gfSACenterBorder').css({
              transform: 'rotate(' + g + 'deg)',
            });

            $gfShadowAngle.find('.gfSARight input').val(g);
            _this.settings.onSelected(g);
            // TODO: check if history-change works
            $element.attr('value', g).val(g).trigger('input-change').trigger('history-change');

            $gfShadowAngle.find('.centered').removeClass('rotate');
          }
        });

      let delay;
      $gfShadowAngle
        .find('.gfSARight input')
        .off('keyup change paste')
        .on('keyup change paste', function (e) {
          clearTimeout(delay);
          const value = parseInt($(this).val());
          delay = setTimeout(function () {
            if (Number.isInteger(value)) {
              $gfShadowAngle.find('.gfSACenterBorder').css({
                transform: 'rotate(' + parseInt(value) + 'deg)',
              });
              _this.settings.onSelected(value);
              _this.settings.onHistoryAdded();
              // TODO2: check if history-change works
              $element.attr('value', value).val(value).trigger('input-change').trigger('history-change');
            }
          }, 200);
        });

      $gfShadowAngle
        .find(
          '.gfSAItem1 svg,.gfSAItem2 svg,.gfSAItem3 svg,.gfSAItem4 svg,.gfSAItem5 svg,.gfSAItem6 svg,.gfSAItem7 svg,.gfSAItem8 svg',
        )
        .off('click')
        .on('click', function (e) {
          const $that = jQuery(this).parent();
          switch ($that.attr('class')) {
            case 'gfSAItem1':
              _this.setValue(270, 'change');
              $element.attr('value', 270).val(270).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem2':
              _this.setValue(180, 'change');
              $element.attr('value', 180).val(180).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem3':
              _this.setValue(225, 'change');
              $element.attr('value', 225).val(225).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem4':
              _this.setValue(315, 'change');
              $element.attr('value', 315).val(315).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem5':
              _this.setValue(135, 'change');
              $element.attr('value', 135).val(135).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem6':
              _this.setValue(45, 'change');
              $element.attr('value', 45).val(45).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem7':
              _this.setValue(0, 'change');
              $element.attr('value', 0).val(0).trigger('input-change').trigger('history-change');
              break;
            case 'gfSAItem8':
              _this.setValue(90, 'change');
              $element.attr('value', 90).val(90).trigger('input-change').trigger('history-change');
              break;
          }
          _this.settings.onHistoryAdded();
        });

      return false;
    };

    this.setValue = function (value, type) {
      const $gfShadowAngle = $element.next('.gfShadowAngle');
      $gfShadowAngle.find('.gfSARight input').val(value);
      $gfShadowAngle.find('.gfSACenterBorder').css({
        transform: 'rotate(' + parseInt(value) + 'deg)',
      });
      if (type == 'change') {
        _this.settings.onSelected(value);
      }
      return false;
    };

    this.init();
  };
  jQuery.fn.gfShadowAngle = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfshadowangle')) {
        const plugin = new jQuery.gfShadowAngle(this, options);
        jQuery(this).data('gfshadowangle', plugin);
      }
    });
  };
})(jQuery);

(function (jQuery) {
  jQuery.gfShadowStyle = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.refresh();
    };

    this.refresh = function () {
      const $dad = $element.closest('.columns');

      const $advanced = $dad.next('.columns-advanced');

      if ($advanced.find('input[name="box-shadow-angle"]').length > 0) {
        var $shadowAngle = $advanced.find('input[name="box-shadow-angle"]');
        var $shadowBlur = $advanced.find('input[name="box-shadow-blur"]');
        var $shadowDistance = $advanced.find('input[name="box-shadow-distance"]');
      } else {
        // Text Shadow
        var $shadowAngle = $advanced.find('input[name="gf-to-shadowXY"]');
        var $shadowBlur = $advanced.find('input[name="box-shadow-blur"]');
        var $shadowDistance = $advanced.find('input[name="box-shadow-spread"]');
      }

      $element.gfSegment({
        title: 'Shadow Style',
        onSelected: function (value) {
          if (value == 'outer') {
            $shadowAngle.attr('value', '0').val('0').trigger('input-change').trigger('value-change');
            $shadowBlur.attr('value', '10').val('10').trigger('input-change').trigger('value-change');
            $shadowDistance.attr('value', '0').val('0').trigger('input-change').trigger('value-change');
          }
          if (value == 'drop') {
            $shadowAngle.attr('value', '45').val('45').trigger('input-change').trigger('value-change');
            $shadowBlur.attr('value', '10').val('10').trigger('input-change').trigger('value-change');
            $shadowDistance.attr('value', '14').val('14').trigger('input-change').trigger('value-change');
          }
          if (value == '') {
            $shadowAngle.attr('value', '0').val('0').trigger('input-change').trigger('value-change');
            $shadowBlur.attr('value', '0').val('0').trigger('input-change').trigger('value-change');
            $shadowDistance.attr('value', '0').val('0').trigger('input-change').trigger('value-change');
          }
        },
      });
    };

    this.init();
  };
  jQuery.fn.gfShadowStyle = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfshadowstyle')) {
        const plugin = new jQuery.gfShadowStyle(this, options);
        jQuery(this).data('gfshadowstyle', plugin);
      }
    });
  };
})(jQuery);

// Text Shadow
(function (jQuery) {
  jQuery.gfShadowXY = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    let $shadowStyle;
    let $shadowDistance;
    let $shadowAngle;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      $element.after(
        '<input type="text" name="box-shadow-distance" data-name="box-shadow-distance" min="0" max="50" step="1" unit="px" value="5" default_value="5" data-caption="Shadow Distance" />',
      );
      $element.after(
        '<input type="text" name="box-shadow-angle" data-caption="Shadow Angle" data-name="box-shadow-angle" value="45" />',
      );

      const $dad = $element.closest('.columns-advanced');
      $shadowDistance = $dad.find('input[name="box-shadow-distance"]');
      $shadowAngle = $dad.find('input[name="box-shadow-angle"]');

      const $column = $dad.prev('.columns');
      $shadowStyle = $column.find('input[name="box-shadow-style"]');

      var xy = $element.val().split(',');
      var xy = _this.convertXYtoAngleDistance(xy[0], xy[1]);

      if (!isNaN(xy[0]) && !isNaN(xy[1])) {
        if (parseInt(xy[1]) == 0) {
          $shadowStyle.attr('value', 'outer').val('outer').trigger('value-change');
        } else {
          $shadowStyle.attr('value', 'drop').val('drop').trigger('value-change');
        }
      }
      _this.applyEvents();

      $element.on('value-change', function () {
        let xy = $element.attr('value').split(',');
        xy = _this.convertXYtoAngleDistance(xy[0], xy[1]);
        $shadowAngle.attr('value', xy[0]).val(xy[0]).trigger('value-change');
        $shadowDistance.attr('value', xy[1]).val(xy[1]).trigger('value-change');
      });

      return false;
    };

    this.applyEvents = function () {
      $shadowAngle.gfShadowAngle({
        title: 'Shadow Angle',
        onSelected: function (value) {
          _this.onChangeValue(value, null);
        },
        onHistoryAdded: function () {
          $element.trigger('history-change');
        },
      });

      $shadowDistance.gfRangePicker({
        title: 'Shadow Distance',
        onSelected: function (value) {
          _this.onChangeValue(null, value);

          if (parseInt(value) == 0) {
            $shadowStyle.attr('value', 'outer').val('outer').trigger('value-change');
          } else {
            $shadowStyle.attr('value', 'drop').val('drop').trigger('value-change');
          }
        },
        onHistoryAdded: function () {
          $element.trigger('history-change');
        },
      });
    };

    this.onChangeValue = function (angle, distance) {
      if (angle == null) {
        angle = $shadowAngle.val();
      }
      if (distance == null) {
        distance = $shadowDistance.val();
      }

      const radian = angle * (Math.PI / 180);
      const x = Math.cos(radian) * parseFloat(distance);
      const y = Math.sin(radian) * parseFloat(distance);

      const xy = x + ',' + y;
      $element.attr('value', xy).val(xy).trigger('input-change');
    };

    this.convertXYtoAngleDistance = function (x, y) {
      var x = parseFloat(x);
      var y = parseFloat(y);

      let angle = Math.round(Math.atan2(y, x) * (180 / Math.PI));
      if (angle < 0) {
        angle = 360 + angle;
      }
      // Distance là cạnh huyền;
      const distance = Math.round(Math.sqrt(x * x + y * y));

      return [angle, distance];
    };

    this.init();
  };
  jQuery.fn.gfShadowXY = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfshadowxy')) {
        const plugin = new jQuery.gfShadowXY(this, options);
        jQuery(this).data('gfshadowxy', plugin);
      }
    });
  };
})(jQuery);
